import { IModel, Model } from '@common/models/Model';

export interface IConfigurationOverrideModel extends IModel {
  configurationOverrideId: number;
  configurationKey: string;
  configurationValue: string;
  configurationOverrideKey: string;
}

export class ConfigurationOverrideModel
  extends Model
  implements IConfigurationOverrideModel
{
  configurationOverrideId: number;
  configurationKey: string;
  configurationValue: string;
  configurationOverrideKey: string;

  constructor(params: Partial<IConfigurationOverrideModel>) {
    super(params);
    this.configurationOverrideId = params.configurationOverrideId || 0;
    this.configurationKey = params.configurationKey || '';
    this.configurationValue = params.configurationValue || '';
    this.configurationOverrideKey = params.configurationOverrideKey || '';
  }
}
